import { useEffect } from 'react'
import { isEmpty, omitBy } from 'lodash'
import { HmacSHA256 } from 'crypto-js'

const FeaturebaseIntegration = ({ user }) => {
  useEffect(() => {
    if (isEmpty(user)) return

    // TODO: REPLACE BY BACKEND HASH
    const { VITE_FEATUREBASE_KEY } = import.meta.env
    const userIdentifier = user.userId
    const userHash = HmacSHA256(userIdentifier, VITE_FEATUREBASE_KEY).toString()

    const organization = 'docutools'

    const win = window

    if (typeof win.Featurebase !== 'function') {
      win.Featurebase = function () {
        (win.Featurebase.q = win.Featurebase.q || []).push(arguments)
      }
    }

    if (!document.getElementById('featurebase-sdk')) {
      const script = document.createElement('script')
      script.src = 'https://do.featurebase.app/js/sdk.js'
      script.id = 'featurebase-sdk'
      script.async = true
      document.body.appendChild(script)

      script.onload = () => {
        const customFields = {
          jobTitle: user.jobTitle,
          plan: user.subscriptionInfo?.tier?.name,
          phone: user.phone,
          city: user.city,
          zip: user.zip,
          owner: user.owner ? 'true' : 'false'
        }

        // Remove null fields or empty
        const cleanedCustomFields = omitBy(
          customFields,
          (value) => value == null || value === ''
        )

        win.Featurebase(
          'identify',
          {
            organization,
            locale: user.settings.language,
            email: user.email,
            name: `${user.firstName} ${user.lastName}`,
            id: user.userId,
            customFields: cleanedCustomFields,
            userHash,
            companies: [
              {
                id: user.organisationId,
                name: user.organisationName ?? ''
              }
            ]
          },
          (err) => {
            if (err) {
              console.error('Featurebase Error:', err)
            } else {
              console.log('Featurebase data sent successfully!')
            }
          }
        )
      }
    }
  }, [user])

  return null
}

export default FeaturebaseIntegration
